import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { CART_TEST_IDS } from './Cart.consts';
import { useServiceType } from 'hooks/context/serviceType';

export const CartServicesDineIn: FC = () => {
  const { t } = useTranslation();
  const { tableDetails } = useServiceType();
  const tableNumber = tableDetails?.name || '';

  return (
    <>
      <Dropdown
        readonly
        label={t('cart.orderType')}
        defaultValue={t('serviceTypes.dine_in')}
        dataTestId={CART_TEST_IDS.orderTypeDropDownBtn}
      />
      {tableNumber && (
        <Dropdown readonly label={t('cart.table')} defaultValue={tableNumber} dataTestId={CART_TEST_IDS.tableNumber} />
      )}
    </>
  );
};
